module.exports = __webpack_public_path__ + "img/bank-submit-h.c6069a8c.png";